import RelationStore from '../../store/RelationStore';

const uPerson = (
  relationStore: RelationStore,
  personid: number,
  imageid?: string|number,
  galleryid?: string,
  faceurl?: string,
) => {
  galleryid =
    typeof galleryid != 'undefined' && galleryid !== null
      ? galleryid
      : (window.dataDetail ? window.dataDetail!.id : window.gallery.id) + '';
  relationStore.getPerson(
    (window.dataDetail ? window.dataDetail!.id : window.gallery.id) + '',
    personid,
    imageid ? +imageid : 0,
    undefined, 
    faceurl
  );
  return relationStore.getPersonAlbum(galleryid, personid);
};

export default uPerson;
